import React, { useEffect, useRef, useState } from "react";
import * as pri from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { Form, FormikProvider, useFormik, Field } from "formik";
import * as Yup from 'yup';
import { Stepper, Step, StepLabel, Box, Typography } from '@mui/material';
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { validateVerhoeffAadhaar } from "../validate-aadhar";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonAxios";
import { getDeviceDetails } from "../../Components/Taxes/DCB/AuthenticationDevicesFunction";
import axios from "axios";
import { config } from "../CommonURLS";


const AadhaarAuthentication = ({ type }) => {
    const rowdatauth_gen = useSelector((state) => state.reducers?.commonmastersreducer?.rowdatauth);
    const aadhaarnumauth_gen = useSelector((state) => state.reducers?.commonmastersreducer?.aadhaarnumauth);



    useEffect(() => {if (aadhaarnumauth_gen) {formik.setFieldValue('aadhaarNo', aadhaarnumauth_gen)}}, [])


    const steps = ['Enter Aadhaar Number', 'Enter OTP & Submit', 'Proceed'];const [activeStep, setActiveStep] = useState(0);
    const [otp, setOtp] = useState(Array(6).fill(""));const inputRefs = useRef([]);
    const dispatch = useDispatch();
    const validationSchema = Yup.object().shape({
        aadhaarNo: Yup.string().required("Aadhaar is required")
            .test("is-valid-aadhaar", "Invalid Aadhaar!", function (value) {
                if (!value) return false;return validateVerhoeffAadhaar(value);}),
        otp: Yup.string()
            .when('step', {is: 1,then: Yup.string().length(6, "OTP must be 6 digits").required("OTP is required"),}),
    });
    const [getUserAdharDetails, setuserAadharDetails] = useState({})
    const formik = useFormik({
        initialValues: {
            deviceType: "",type_device_mobile: "",
            txnOtp: "",otp: "",
            aadhaarNo: "",step: 0
        },validationSchema: validationSchema,
        onSubmit: (values) => {
            if (activeStep === 0) {
                // axios.get(config.url.API_URL + "citizen-service/intiate-otp/" + values.aadhaarNo).then((res) => {
                //     toast.success("Otp Send Successfully");
                //     setActiveStep(1);
                //     formik.setFieldValue('step', 1);
                //     formik.setFieldValue('txnOtp', res?.data?.txn);
                // });

let payload={aadharno:values.aadhaarNo,unique_key: "d35cfd929c5365b7710278838764ac61",}
                axios.post(config?.url?.API_URL+"citizen-service/otp-generation-outside",payload).then((res)=>{
                    if(res?.data?.scode==="01"){
                        toast.success(res?.data?.sdesc);setActiveStep(1);
                    formik.setFieldValue('step', 1);formik.setFieldValue('txnOtp', res?.data?.txnNo);
                    }
                })}
            else if (activeStep === 1) {
                axios.post(config.url.API_URL + "citizen-service/ekyc-otp-validation-outside",
                    {
                        aadharno: values?.aadhaarNo,unique_key: "d35cfd929c5365b7710278838764ac61",
                        otp: values?.otp,txnNo: values?.txnOtp,
                    }).then((res) => {
                        if (res?.data?.scode == "02") {Swal.fire("Invalid Otp", "", "info");}
                        else {
                            setuserAadharDetails(res?.data?.response)
                            dispatch({
                                type: "ADHARMOBILE",
                                payload: {authdata: res?.data?.response,dataauth2: rowdatauth_gen == 'empty' ? "100" : rowdatauth_gen}
                            });
                            setActiveStep(2);dispatch({ type: "VERIFYSTATUSADHAAR", payload: 'yes' });formik.setFieldValue('step', 2);
                        }});}}});

    function getAadharThump() {
        if (formik?.values?.deviceType == "" || formik?.values?.deviceType == null || formik?.values?.deviceType == undefined) {Swal.fire("Please Select Device Type", "", "info")}
        else if (formik?.values?.aadhaarNo == "" || formik?.values?.aadhaarNo == null || formik?.values?.aadhaarNo == undefined) {Swal.fire("Please Enter Aadhaar Number", "", "info")
        }
        else {
            const { deviceType } = formik.values;
            const deviceDetails = getDeviceDetails(formik?.values?.deviceType);fetchData();
            async function fetchData() {
                const result = await deviceDetails;
                let values = {
                    device_slno: result?.srno,deviceType: 1,
                    device_name: result?.device_name,uid: formik?.values?.aadhaarNo,
                    pid: result?.pid,mi: result?.mi
                };

                if (result?.pid) {axios.post(config.url.API_URL + "citizen-service/Aadharauthoutside", values).then((res) => {
                        if (res?.data?.scode === "01") {
                            Swal.fire(res?.data?.sdesc, "", "success");setuserAadharDetails(res?.data)
                            dispatch({
                                type: "ADHARMOBILE",
                                payload: {authdata: res?.data,dataauth2: rowdatauth_gen == 'empty' ? "100" : rowdatauth_gen}
                            });
                            setActiveStep(2);
                            // fetchDevicesInformation();
                        } else if (res?.data?.scode == "02") {Swal.fire(res?.data?.sdesc, "", "error");
                        }
                        else if (res?.data?.scode == "03") {Swal.fire(res?.data?.sdesc, "", "error");
                        }
                    });}}}
    }

    const handleKeyDown = (e) => {
        const index = inputRefs.current.indexOf(e.target);
        if (!/^[0-9]{1}$/.test(e.key) &&e.key !== "Backspace" &&e.key !== "Delete" &&e.key !== "Tab" &&!e.metaKey) {
            e.preventDefault();}

        if (e.key === "Backspace") {
            setOtp((prevOtp) => {
                const updated = [...prevOtp];
                if (updated[index]) {updated[index] = "";} 
                else if (index > 0) {
                    updated[index - 1] = "";inputRefs.current[index - 1].focus();
                }
                formik.setFieldValue("otp", updated.join(""));return updated;
            });e.preventDefault();
        }
    };

    const handleInput = (e) => {
        const { value } = e.target;
        const index = inputRefs.current.indexOf(e.target);
        if (/^[0-9]$/.test(value)) {
            const updatedOtp = [...otp];updatedOtp[index] = value;
            setOtp(updatedOtp);formik.setFieldValue("otp", updatedOtp.join(""));
            if (index < 5) {inputRefs.current[index + 1]?.focus();}
        }};

    const handleFocus = (e) => e.target.select();

    const handlePaste = (e) => {
        e.preventDefault();const text = e.clipboardData.getData("text").trim();
        if (!/^[0-9]{6}$/.test(text)) return;
        const digits = text.split("");setOtp(digits);formik.setFieldValue("otp", digits.join(""));
    };
    const handleClear = () => {
        setOtp(Array(6).fill(""));inputRefs.current[0]?.focus(); // Optional: focus first input
    };
    useEffect(() => {
        formik.setFieldValue("deviceType", "");setActiveStep(0)
        formik.setFieldValue("otp", "");formik.setFieldValue("txnOtp", "")
        formik.setFieldValue("step", 0);handleClear();
        dispatch({ type: "AADHAARVERIFIEDDATA", payload: {} });}, [])


    useEffect(() => {formik.setFieldValue("deviceType", "") }, [])

    return (
        <>
            <FormikProvider value={formik}><Form onSubmit={formik.handleSubmit} onChange={formik.handleChange} >
                    <pri.Container >
                        <pri.Row><pri.Col xs={12}><div className="inner-herbpage-service-title1 d-flex"><h1><span>Verify Your</span><br />Aadhaar Identity</h1>
                                    {/* <button
                                className="btn btn-primary back-button ms-auto"
                                onClick={() => navigate("/")}
                            >
                                <TbArrowBackUp className="back-icon" />Back
                            </button> */}
                                </div></pri.Col></pri.Row></pri.Container>


                    <Box sx={{ width: '100%' }}>
                        <Stepper activeStep={activeStep} alternativeLabel>{steps.map((label, index) => (
                                <Step key={label} completed={index < activeStep}>
                                    <StepLabel sx={{'& .MuiStepLabel-label': {color: '#360d0d !important',fontSize: '13px',fontWeight: 'bold'},}}>{label}</StepLabel></Step>
                            ))}</Stepper>
                    </Box>

                    <section
                     className="bg-white py-5 dark:bg-dark">
                        <div
                         className="container d-flex flex-column align-items-center">
                            {activeStep === 0 && (
                                <>
                                    <pri.Row
                                     className="justify-content-center align-items-center mb-3">
                                        <div
                                         className="form-check form-check-inline mx-2">
                                            <Field 
                                            type="radio" name="type_device_mobile" value="mobile" className="form-check-input" />
                                            <label 
                                            className="form-check-label" htmlFor="mobileOption">Mobile OTP</label>
                                        </div>

                                        <div
                                         className="form-check form-check-inline mx-2">
                                            <Field type="radio" name="type_device_mobile" value="device" className="form-check-input" id="deviceOption"
                                            // onClick={(e) => { formik.setFieldValue("aadhaarNo", "") }}
                                            /><label className="form-check-label" htmlFor="deviceOption">Device</label>
                                        </div>
                                    </pri.Row>

                                    {formik?.values?.type_device_mobile && <>
                                        <pri.Row
                                             className="justify-content-center align-items-center mb-3 w-50">
                                            <label >Aadhaar Number</label>
                                            <Field type="text" id="aadhaarNo"
                                                name="aadhaarNo" maxLength="12"
                                                className="form-control text-center" disabled={true}
                                                placeholder="12-digit Aadhaar number" onChange={formik.handleChange}
                                                onBlur={formik.handleBlur} value={formik.values.aadhaarNo}
                                            />
                                            {formik.errors.aadhaarNo && formik.touched.aadhaarNo && (<div className="text-danger mt-2 text-center">{formik.errors.aadhaarNo}</div>)}
                                        </pri.Row>
                                    </>}

                                    {/* Device Authentication */}
                                    {formik?.values?.type_device_mobile === "device" && (
                                        <pri.Row
                                         className="justify-content-center align-items-center mb-3 w-50">
                                            <Field
                                             type="hidden" name="pid" id="pid" />
                                            <label >Device</label>
                                            <Field as="select" className="form-select" name="deviceType">
                                                <option value="">-- Select Device --</option>
                                                <option value="startek">Startek (Fingerprint)</option><option value="secugen">Secugen Hamster Pro 20</option>
                                                <option value="mantra">Mantra MFS 100</option><option value="iritech_10cm_1">IriShield UL</option>
                                                <option value="irishieldu">IriShield U</option><option value="irisbiojini">Biojini-Biomatics</option>
                                            </Field>
                                            <pre></pre>
                                            <div className="col-md-3 text-center">
                                                <pri.Button type="button" className="btn btn-success" onClick={(e) => { getAadharThump() }}>Authenticate</pri.Button>
                                            </div>
                                        </pri.Row>)}</>)}
                            {activeStep === 1 && (
                                <>
                                    <label 
                                    className="form-label mb-3 text-sm text-muted">Enter the 6-digit OTP</label>
                                    <div 
                                    className="d-flex gap-2 justify-content-center mb-3">
                                        {Array(6).fill().map((_, index) => (
                                            <input key={index}
                                                type="text" maxLength={1}
                                                value={otp[index]} onChange={handleInput}
                                                onKeyDown={handleKeyDown} onFocus={handleFocus}
                                                onPaste={handlePaste} ref={(el) => (inputRefs.current[index] = el)}
                                                className="form-control text-center p-1"
                                                style={{ width: "40px", height: "40px", fontSize: "18px", fontWeight: "500",
                                                }}
                                            />
                                        ))}

                                    </div>
                                    {formik.errors.otp && formik.touched.otp && (
                                        <div style={{ color: "red", marginTop: "8px" }}>{formik.errors.otp}</div>
                                    )}
                                </>
                            )}
                            {activeStep === 2 && getUserAdharDetails?.name && (
                                <Typography variant="h6" sx={{ color: "green", fontWeight: 600 }}>
                                    ✅ Aadhaar verification successful for <strong>{getUserAdharDetails?.name}</strong> (xxxxxx{formik?.values?.aadhaarNo?.toString().slice(-4)})</Typography>

                            )}
                            {(activeStep < 2 && formik?.values?.type_device_mobile == "mobile") && (
                                <button type="submit" className="btn btn-success btn-sm px-4 mt-3">{activeStep === 0 ? 'Send OTP' : 'Verify'}</button>)}
                        </div>
                    </section>
                    <ToastContainer
                     position="top-center" autoClose={3000} />
                </Form></FormikProvider ></>);
};

export default AadhaarAuthentication;